module.exports = __webpack_public_path__ + "img/1518396478.9d22554a.jpg";